(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artnovae-editorial-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('artnovae-moods')) {
  customElements.define('artnovae-moods', class extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.initialize()); }
    initialize() {
      this.track = this.querySelector('.an-moods__track');
      this.cards = [...this.querySelectorAll('.an-moods__item')];
      if (!this.track || !this.cards.length) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous = this.querySelector('[data-mood-prev]');
      this.next = this.querySelector('[data-mood-next]');
      this.count = this.querySelector('.an-moods__count');
      this.index = 0;
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const card = this.cards.find(item => item === event.target || item.contains(event.target));
        if (card) this.go(this.cards.indexOf(card));
      }, options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.track);
      this.update();
    }
    update() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const left = this.track.scrollLeft;
      this.index = this.cards.reduce((best, item, i) => {
        return Math.abs(item.offsetLeft - left) < Math.abs(this.cards[best].offsetLeft - left) ? i : best;
      }, 0);
      this.previous.disabled = left <= 2;
      this.next.disabled = left >= max - 2;
      const current = this.next.disabled ? this.cards.length : this.index + 1;
      this.count.textContent = String(current).padStart(2, '0') + ' / ' + String(this.cards.length).padStart(2, '0');
    }
    move(direction) {
      if (direction < 0 && this.next.disabled) {
        const target = [...this.cards].reverse().find(item => item.offsetLeft < this.track.scrollLeft - 2);
        if (target) { this.go(this.cards.indexOf(target)); return; }
      }
      this.go(Math.min(this.cards.length - 1, Math.max(0, this.index + direction)));
    }
    go(index) {
      this.track.scrollTo({
        left: this.cards[index].offsetLeft,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.abort?.abort();
      this.resize?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
